module.exports = __webpack_public_path__ + "static/media/ic_check-primary.a9b02cec.svg";